import { z } from 'zod';

export const fileSchema = z.object({
	size: z.coerce.number(),
	file: z.instanceof(File),
});

export const fileServerSchema = fileSchema.extend({
	file: z.string(),
});
